import { Repository } from "./Repository";

export class EtcRepository extends Repository {
  async getDeepLinkInfo(shortLink: string): Promise<{type: string, id: string}> {
    const path = `/v1/etc/app/deepLinkInfo/${shortLink}`;
    const response = await Repository.client.get(path);
    return response.data.data;
  }
}

// Create a singleton instance
export const etcRepository = new EtcRepository();